import { Container, Heading, Img, SimpleGrid, Text } from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";
import CardHome from "./CardHome";

const SkillsOverView = () => {
    return (
        <Container maxW={"container.lg"}>
            <Heading size={"md"} className="text-center mt-12 mb-2 font-mono font-bold text-2xl">
            Technologies That I know 
            </Heading>

            <hr className="mb-6 mx-60 border-blue-400 dark:border-lime-400" />

            <SimpleGrid columns={[1,2, 3 ,4 ]} spacing="2">
                <CardHome
                    bg={"bg-sky-400 hover:bg-sky-500"}
                    title="React"
                    text={"React is a JavaScript library used in web development to build interactive elements on websites."}
                    photo={"https://i.ibb.co/ykFWKhm/react-logo-7-B3-CE81517-seeklogo-com.png"}
    

                />
                <CardHome
                    bg={"bg-orange-600 hover:bg-orange-500"}
                    title="Node.js"
                    text={"An open source development platform for executing JavaScript code server-side. Built on V8 engine"}
                    
                    photo={"https://i.ibb.co/8BHxcf0/nodejs-logo.png"}
                /><CardHome
                bg={"bg-orange-600 hover:bg-orange-500"}
                title="WordPress"
                text={"A content management system (CMS) that allows you to host and build websites & customization."}
               
                photo={'https://i.ibb.co/p4w1L6m/wordpress-icon-logo-45667-D3313-seeklogo-com.png'}
            />
                <CardHome
                    bg={"bg-green-700 hover:bg-green-600"}
                    title="Java Script"
                    text={"JavaScript is a lightweight interpreted programming language. JS is a scripting language"}
                    photo={"https://i.ibb.co/1807btj/javascript-logo-1.png"}
                />
                <CardHome
                    bg={"bg-orange-600 hover:bg-orange-500"}
                    title="Firebase"
                    text={"App development platform that helps build and grow apps and games. Backed by Google & trusted by millions of businesses."}
                    photo={"https://i.ibb.co/5BvwJx5/firebase-logo-402-F407-EE0-seeklogo-com.png"}
                />
                
                <CardHome
                    bg={"bg-amber-900 hover:bg-amber-800"}
                    title="WooCommerce"
                    text={"WooCommerce is a free plugin. It lets you turn a WordPress website into an ecommerce store. WooCommerce is fully compatible on WP."}
                    photo={"https://i.ibb.co/zQ3xBFS/woocommerce-logo-FD415224-B8-seeklogo-com.png"}
                />
                <CardHome
                    bg={"bg-amber-900 hover:bg-amber-800"}
                    title="PhotoShop"
                    text={"Adobe Photoshop is software that is extensively used for raster image editing, graphic design and digital art."}
                    photo={"https://i.ibb.co/PxVx8vS/adobe-photoshop-logo-7-B88-D7-B5-AA-seeklogo-com.png"}
                />
                <CardHome
                    bg={"bg-sky-500 hover:bg-sky-400"}
                    title="Tailwind Css"
                    text={"Tailwind CSS is basically a utility-first CSS framework for rapidly building custom user interfaces, highly customizable."}
                    photo={"https://i.ibb.co/sJfBdgg/tailwind-css-logo-5-AD4175897-seeklogo-com.png"}
                /> 
      
            </SimpleGrid>
            <Text
                fontSize={"sm"}
                className="font-mono rounded py-3 text-center my-3 bg-blue-300 dark:bg-lime-300 hover:bg-yellow-300 dark:hover:bg-yellow-300 dark:text-black"
            >
                Please Visit the skills sections to know .
                <Link className="underline font-bold" to="/skills#root">
                    all the skills i have got &rarr;{" "}
                </Link>
            </Text>
        </Container>
    );
};

export default SkillsOverView;